import { enums, supplemental } from '../../../utils';
import { PaymentPreferencesModel } from '../../../data-models';
import { IFormContext } from '../../../contexts/form-context';
import { getPaymentPreferences } from '../../../utils/web-apis-client';
import { getSimpleRemoteConfig } from '../../../utils/remote-config-manager';

export const getPreferenceMethods = async (
  setFormContext: Function,
  communicationPreferences: any,
) => {
  const prefs = (await getPaymentPreferences()) as PaymentPreferencesModel;
  const commsPrefs = communicationPreferences;

  if (prefs && commsPrefs) {
    const smsPref = commsPrefs?.communicationPreferences?.find(
      (c: any) => c.preferenceType === 'Texting',
    );
    setFormContext((fc: IFormContext) => ({
      ...fc,
      paymentMethod: prefs.paymentMethod,
      smsOptIn: smsPref?.preferenceValue,
    }));
  }
};

export const setFieldsFromRemoteConfig = async (
  setFormContext: Function,
  companyCode: string | undefined,
) => {
  const con = await getSimpleRemoteConfig();

  if (con) {
    const list = con[enums.RemoteConfigKeys.hidePrefsForId];

    const employerEnabled = supplemental.isEmployerEnabledSync(
      con,
      companyCode,
    );
    setFormContext((fc: IFormContext) => ({
      ...fc,
      config: con,
      hidePaymentPrefs: list,
      isVBEmployerEnabled: employerEnabled,
    }));
  }
};

export const setLeaveOnlyFlag = (
  formContext: IFormContext,
  setFormContext: Function,
) => {
  let leaveOnly = false;
  const formName = formContext.formName;

  if (formName === 'Pregnancy') {
    leaveOnly = !formContext.eeCentric?.stdEligible[9280003];
  } else if (formName === 'Personal Medical') {
    leaveOnly =
      !formContext.eeCentric?.stdEligible[9280002] &&
      !formContext.eeCentric?.stdEligible[9280001];
  }

  setFormContext((fc: IFormContext) => ({
    ...fc,
    leaveOnly,
  }));
};

export const getVBCoverage = async (
  setFormContext: Function,
  anyVBCoverage: boolean,
) => {
  setFormContext((fc: IFormContext) => ({
    ...fc,
    hasVBCoverage: anyVBCoverage,
  }));
};

export const showSteps = (form: any, steps: any, currentStepIndex: number) => {
  return (
    form &&
    form?.elements.flags?.value.filter(
      (f: any) => f.codename === enums.FormFlags.showSteps,
    ).length > 0 &&
    steps &&
    steps.length > 1 &&
    form?.elements.steps?.linkedItems?.[
      currentStepIndex
    ]?.elements.flags?.value.filter(
      (f: any) => f.codename === enums.FormStepFlags.hideStepper,
    ).length === 0
  );
};
